export enum ChurnTier {
  SAFE = 'SAFE',
  WATCH = 'WATCH',
  AT_RISK = 'AT_RISK',
  CRITICAL = 'CRITICAL',
}

export enum SystemCohortType {
  CHURN_WATCH = 'CHURN_WATCH',
  CHURN_AT_RISK = 'CHURN_AT_RISK',
  CHURN_CRITICAL = 'CHURN_CRITICAL',
  POWER_USERS = 'POWER_USERS',
  NEW_USERS = 'NEW_USERS',
  SOCIAL_CONNECTORS = 'SOCIAL_CONNECTORS',
  LAPSED_MEMBERS = 'LAPSED_MEMBERS',
  WEEKEND_WARRIORS = 'WEEKEND_WARRIORS',
  PAYMENT_ISSUES = 'PAYMENT_ISSUES',
}

export class ChurnSignalsDto {
  bookingFrequencyDecline: number;
  daysSinceLastBooking: number;
  paymentFailure: number;
  socialIsolation: number;
  subscriptionStatus: number;
  cancellationRate: number;
  walletDepletion: number;
}

export class UserChurnScoreDto {
  id: string;
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  score: number;
  tier: ChurnTier;
  signals: ChurnSignalsDto;
  calculatedAt: string;
}

export class ChurnDistributionDto {
  safe: number;
  watch: number;
  atRisk: number;
  critical: number;
  total: number;
}

export class SmartCohortCardDto {
  id: string;
  name: string;
  systemType: SystemCohortType;
  memberCount: number;
  description?: string;
}
